import React, { createContext, useContext, useEffect, useState } from 'react';
import { getSocialMedia } from '../services/api';
import { SOCIAL_LINKS as DEFAULT_LINKS } from '../constants';

interface SocialContextType {
  socialLinks: typeof DEFAULT_LINKS;
  loading: boolean;
}

const SocialContext = createContext<SocialContextType>({
  socialLinks: DEFAULT_LINKS,
  loading: false,
});

export const SocialProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [socialLinks, setSocialLinks] = useState(DEFAULT_LINKS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    getSocialMedia()
      .then((data) => {
        if (isMounted && data) {
          setSocialLinks((prev) => ({
            instagram: data.instagram || prev.instagram,
            x: data.x || prev.x,
            tiktok: data.tiktok || prev.tiktok,
            youtube: data.youtube || prev.youtube,
            facebook: data.facebook || prev.facebook,
          }));
        }
      })
      .catch((err) => {
        console.error('Failed to load social links from Strapi:', err);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <SocialContext.Provider value={{ socialLinks, loading }}>
      {children}
    </SocialContext.Provider>
  );
};

export const useSocialLinks = () => useContext(SocialContext);
